import { Route } from '@angular/router';
import { VerificationComponent } from 'src/app/pages/network/verification/verification.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const verification: Route = {
  path: 'verification',
  title: 'nav.network.verification',
  data: {
    breadcrumb: 'nav.network.verification',
    icon: SbIcons.bookingVerification,
    id: RoutingID.verification,
  },
  children: [
    {
      path: '',
      component: VerificationComponent,
      data: {
        breadcrumb: '',
      },
    },
  ],
};
